import React from 'react';
import ProjectDetail from './ProjectDetail';
import { projectMeta } from './data';
import { toCdn } from '../utils/cdn';
import Figure from '../components/Figure';
import ProgressiveImg from '../components/ProgressiveImg';

export default function Letterfall() {
  const meta = projectMeta.letterfall;
  return (
    <ProjectDetail title={meta.title} date={meta.date} role={meta.role} url={meta.url}>
      {/* Custom per-project content goes here */}

      <p>I've always loved word games, so eventually I decided to make one of my own. That idea turned into Letterfall—a fast-paced mix of Scrabble and Tetris where the goal is to rack up as many points as possible before the letters stack too high.</p>

      <p>It was my first time building a full app from scratch, using SwiftUI and SpriteKit—two frameworks I was just starting to feel comfortable with. The early prototypes were rough, but they were enough to get feedback from friends and family and refine the gameplay. Even in those first versions, I could see the potential.</p>

      <p>After a few weeks of testing and iteration, I polished the gameplay, added leaderboards and achievements, and launched on the App Store and Product Hunt in May 2022—where it climbed to the #4 top product of the day.</p>

      <div className="media-gallery">
        <Figure caption="Gameplay Screenshot">
          <ProgressiveImg
            src={toCdn('/images/projects/letterfall/letterfall_1.webp')}
            alt="Gameplay Screenshot"
            className="gallery-item"
          />
        </Figure>
        <Figure caption="Menu Screenshot">
          <ProgressiveImg
            src={toCdn('/images/projects/letterfall/letterfall_2.webp')}
            alt="Menu Screenshot"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Game Center Screenshot">
          <ProgressiveImg
            src={toCdn('/images/projects/letterfall/letterfall_3.webp')}
            alt="Game Center Screenshot"
            className="gallery-item"
          />
        </Figure>

        <Figure caption="Gameplay Video">
          <div className="video-mask">
            <video
              src={toCdn('/images/projects/letterfall/letterfall.mp4')}
              alt="Gameplay Video"
              className="gallery-item"
              loading="lazy"
              controls
            />
          </div>
        </Figure>
      </div>

    </ProjectDetail>
  );
}
